import type { HomeDto } from '@lmc/ts-common'
import * as GlobalActions from 'actions/Global'
import { postJSON } from 'common/services/api'
import { showToast } from 'common/utils'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'

type GeofencingSettingsPayload = {
  geofencing: boolean
  geofencingMode: string
  geofencingMaxRadius?: number
}

const useUpdateGeofencingSettings = () => {
  const { t } = useTranslation()

  const home = useSelector(
    (state: { global: { home: HomeDto } }) => state.global.home
  )

  const dispatch = useDispatch()

  const mutationFunction = (json: GeofencingSettingsPayload) =>
    postJSON({
      method: 'PUT',
      url: `/list/homes/${home.id}/rota`,
      json
    })

  const { mutateAsync: updateGeofencingSettings, isLoading } = useMutation<
    { data: HomeDto },
    unknown,
    GeofencingSettingsPayload,
    void
  >(
    ['rota-settings', home.id, 'geofencing'],
    (values: GeofencingSettingsPayload) => mutationFunction(values),
    {
      onSuccess: (res) => {
        dispatch(GlobalActions.setHomeDetails(res.data))
        showToast({ title: t('SETTINGS_UPDATED') })
      },
      onError: () => {
        showToast({ title: t('SETTINGS_ERROR'), type: 'error' })
      }
    }
  )

  return { updateGeofencingSettings, isLoading }
}

export default useUpdateGeofencingSettings
